import uitagslist from './uitagslist.js'

const xvnode = (sess, cfg, graph, node, pg, subj) => {
  const { div, a, ul, li } = cfg.h(pg, node)
  const linkmap = subj.linkmap
  const linkmapkeys = Object.keys(linkmap).sort((keya, keyb) => (
    linkmap[keya].length === linkmap[keyb].length
      ? (keya > keyb ? 1 : -1)
      : linkmap[keya].length > linkmap[keyb].length ? -1 : 1))

  return (
    div('.:ui:#:key', linkmapkeys.map(key => (
      div('', [
        div('.:ui-section-head', [
          a('.:ui-section-head-link', {
            id: key,
            href: `/tag/#${key}`,
            title: key
          }, key)
        ]),
        linkmap[key].length && (
          ul('', linkmap[key].map(link => (
            li('', [
              a('.l', {
                href: link.url,
                title: link.description
              }, link.url.replace(/^https:\/\//, '')),
              link.tagsArr &&
                uitagslist.xvnode(sess, cfg, graph, node, uitagslist, {
                  tags: link.tagsArr
                })
            ])
          )))
        )
      ])
    )))
  )
}

export default {
  type: 'uisitemaptags',
  xvnode
}
